import React, { useState, useRef, useCallback, useEffect, forwardRef } from 'react'
import { ResizeObserver } from '~modules/browser'

const mainStyle = { width: '100%', height: '100%', flex: 1, minHeight: 0 }
const cache = {}

export default (Component, cacheId = '') => {
    const VirtualGridAutoSize = forwardRef(function VirtualGridAutoSize(props, forwardedRef) {
        const [size, setSize] = useState(cache[cacheId] || { width: 0, height: 0 })
        const divRef = useRef(null)
        const roRef = useRef(null)

        const bindRef = useCallback(ref => {
            if (!ref || divRef.current == ref) return

            divRef.current = ref
            roRef.current = new ResizeObserver(([div]) => {
                const { width, height } = div.contentRect

                const prev = cache[cacheId] || {}
                if (width != prev.width || height != prev.height) {
                    cache[cacheId] = { width, height }
                    setSize(cache[cacheId])
                }
            })
            roRef.current.observe(ref)
        }, [cacheId])

        useEffect(
            () => () => {
                if (roRef.current) {
                    if (divRef.current) roRef.current.unobserve(divRef.current)
                    roRef.current.disconnect && roRef.current.disconnect()
                }
            },
            []
        )

        const { width } = size

        return (
            <div
                ref={bindRef}
                style={mainStyle}>
                {width ? (
                    <Component
                        {...props}
                        {...size}
                        ref={forwardedRef}
                        containerRef={divRef.current} />
                ) : null}
            </div>
        )
    })

    VirtualGridAutoSize.displayName = `withAutoSize(${Component.displayName || Component.name || 'Component'})`
    return VirtualGridAutoSize
}
